import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme =>({
    root: {
        margin:'5px',
        width: '35px',
        height: '45px'
    },


}));

export default function Mask () {
    const classes = useStyles();
    return (
        <a style={{display: 'table'}} href="https://my.bafta.org/" target="_blank" rel="noreferrer">
            <img src='/images/BAFTA_MASK_RGB_NEG_SMALL.png' title="" className={classes.root} alt="BAFTA Mask" />
        </a>

    );
}